var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 30 30",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8372 1.63513C15.3837 1.18164 14.6512 1.18164 14.1628 1.63513L0 14.7514L1.67442 16.5305L3.13953 15.17V27.484C3.13953 28.1468 3.69767 28.7049 4.36047 28.7049H25.6395C26.3023 28.7049 26.8605 28.1468 26.8605 27.484V15.2049L28.3256 16.5654L30 14.7863L15.8372 1.63513ZM15 25.077C10.6047 25.077 7.04651 21.5189 7.04651 17.1235C7.04651 12.7282 10.6047 9.17001 15 9.17001C19.3953 9.17001 22.9535 12.7282 22.9535 17.1235C22.9535 21.5189 19.3953 25.077 15 25.077Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.221 15.9026V12.9724H13.7791V15.9026H10.8489V18.3444H13.7791V21.2747H16.221V18.3444H19.1512V15.9026H16.221Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthHouse);
export default __webpack_public_path__ + "static/media/health-house.2e4d7e0783b1b6aa16bc66e783db5638.svg";
export { ForwardRef as ReactComponent };